import ViewOrganisation from "./ViewOrganisation";

export default ViewOrganisation